import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { faq } from "../data";

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState(null);

  return (
    <section className="py-4">
      <div className="container py-4" style={{ maxWidth: '800px' }}>
        <h2 className="text-center display-5 fw-bold mb-5 text-white">Часто задаваемые вопросы</h2>
        <div className="accordion" id="faqAccordion">
          {faq.map((item, i) => (
            <div className="accordion-item border-0 mb-3 section-transparent" key={i}>
              <h2 className="accordion-header">
                <button
                  className={`accordion-button ${openIndex === i ? '' : 'collapsed'} bg-transparent text-white`}
                  type="button"
                  onClick={() => setOpenIndex(openIndex === i ? null : i)}
                >
                  {item.q}
                </button>
              </h2>
              <AnimatePresence>
                {openIndex === i && (
                  <motion.div
                    initial={{ height: 0, opacity: 0 }}
                    animate={{ height: 'auto', opacity: 1 }}
                    exit={{ height: 0, opacity: 0 }}
                    transition={{ duration: 0.3 }}
                    className="accordion-collapse"
                  >
                    <div className="accordion-body text-white-50">
                      {item.a}
                    </div>
                  </motion.div>
                )}
              </AnimatePresence>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}